import React, { useEffect, useState } from "react";
import { Button, Drawer, Form, FormProps, Input, Row, Select } from "antd";
import MoroccanPhoneInput from "../LancerVisiteForm/components/MoroccanPhoneInput";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { updateUser } from "../../store/slices/userSlice";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

type FieldType = {
  nom?: string;
  prenom?: string;
  email?: string;
  telephone?: string;
  password?: string;
  verifyPassword?: string;
  role?: string;
  // role
};

interface Props {
  id: number | null;
  onClose: () => void;
  open: boolean;
}

const EditUserDrawer: React.FC<Props> = ({ id, onClose, open }) => {
  const [form] = Form.useForm();
  const { users } = useSelector((state: RootState) => state.user);
  const dispatch: AppDispatch = useDispatch();
  const [userToEdit, setUserToEdit] = useState<any>(null);

  const onFinish: FormProps<FieldType>["onFinish"] = async (values) => {
    const { verifyPassword, ...filteredValues } = values;
    console.log("Filtered Values:", filteredValues);
    console.log(id);

    dispatch(updateUser({ id, newUser: filteredValues }))
      .unwrap()
      .then(() => {
        //form.resetFields();
        toast.success("Utilisateur modifié avec succés");
        onClose();
      })
      .catch((error: any) => {
        console.error("Error adding user:", error);
        toast.error("Une erreur est survenue");
      });
  };

  const onFinishFailed: FormProps<FieldType>["onFinishFailed"] = (
    errorInfo
  ) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    if (id !== null) {
      const user = users.find((user) => user.id === id);
      setUserToEdit(user);
      if (user) {
        form.setFieldsValue({
          ...user,
          password: null,
          verifyPassword: null,
        });
      }
    }
  }, [id, users, form]);

  return (
    <>
      <Drawer title={`Modifier l'utilisateur `} onClose={onClose} open={open}>
        <Form
          form={form}
          name="add_user"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout="vertical"
        >
          <Form.Item<FieldType>
            label="Nom"
            name="nom"
            rules={[{ required: true, message: "Veuillez saisir un nom!" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item<FieldType>
            label="Prénom"
            name="prenom"
            rules={[{ required: true, message: "Veuillez saisir un prénom!" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item<FieldType>
            label="Email"
            name="email"
            rules={[
              {
                required: true,
                message: "Veuillez saisir un email!",
                type: "email",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item<FieldType>
            label="Mot de passe"
            name="password"
            rules={[
              { required: true, message: "Veuillez saisir un mot de passe!" },
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item<FieldType>
            label="Confirmer le mot de passe"
            name="verifyPassword"
            dependencies={["password"]}
            rules={[
              { required: true, message: "Veuillez resaisir le mot de passe!" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Les mots de passe ne correspondent pas!")
                  );
                },
              }),
            ]}
          >
            <Input.Password />
            {/* Disable if password is empty */}
          </Form.Item>

          <Form.Item
            name="telephone"
            label="Telephone"
            rules={[
              {
                required: true,
                message: "Veuillez saisir un numéro de téléphone !",
              },
            ]}
          >
            <MoroccanPhoneInput
              value={userToEdit?.telephone}
              onChange={(value) => {
                form.setFieldValue("telephone", value);
                console.log(value);
              }}
            />
          </Form.Item>

          <Form.Item<FieldType>
            label="Role"
            name="role"
            rules={[{ required: true, message: "Veuillez saisir un role!" }]}
          >
            <Select
              options={[
                { value: "visiteur", label: "visiteur" },
                { value: "controleur", label: "controleur" },
                { value: "admin", label: "admin" },
              ]}
            />
          </Form.Item>
          <Row justify={"end"} style={{ width: "100%" }}>
            <Button
              variant="solid"
              onClick={onClose}
              color="danger"
              style={{ marginRight: "10px" }}
            >
              Annuler
            </Button>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Modifier
              </Button>
            </Form.Item>
          </Row>
        </Form>
      </Drawer>
    </>
  );
};

export default EditUserDrawer;
